import { Component } from '@angular/core';
import { PasswordProviderConfig, PasswordSignatureProvider } from '../services/password.signature-provider';
import { catchError, finalize, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { SignatureAuthorizationResponse } from '../services/authenticated.signature-provider';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { BaseDirectiveObject } from '../../../app/components/common/base-directive-object';
import { FieldConfig } from '../../../app/api/contract-notice-dto';
import { SignatureStatus } from '../signature.objects';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';

export class UserPassword {
  public user: string;
  public password: string;
}

@Component({
  templateUrl: 'signature-password.template.html',
  selector: 'signature-password',
  providers: [DialogService]
})
export class SignaturePasswordAuthComponent extends BaseDirectiveObject {

  public errorMsg: string;
  private authProvider: PasswordSignatureProvider;
  public data: UserPassword;
  public config: PasswordProviderConfig;
  public show_spin = false;


  constructor(dialogConfig: DynamicDialogConfig, private dialogRef: DynamicDialogRef, private plycaErrorHandler: PlycaErrorHandler) {
    super();
    this.authProvider = dialogConfig?.data?.authProvider;
    if (this.authProvider === null) {
      throw new Error('Error , no se ha proporcionado provider de firma');
    }
    this.data = new UserPassword();
    this.config = this.authProvider.getProviderConfig() as PasswordProviderConfig;
    this.data.user = this.authProvider.getProviderUserId();
  }

  public getPassWordFieldConfig(): FieldConfig {
    const fieldConfig = new FieldConfig();
    fieldConfig.jsonField = 'password';
    fieldConfig.type = 'TEXT';
    fieldConfig.styleClass = 'w-100';
    fieldConfig.typePassword = true;
    fieldConfig.required = 'true';
    fieldConfig.descriptionKey = 'LoginView.pass';
    return fieldConfig;
  }

  public getUsernameFieldConfig(): FieldConfig {
    const fieldConfig = new FieldConfig();
    fieldConfig.jsonField = 'user';
    fieldConfig.type = 'TEXT';
    fieldConfig.styleClass = 'w-100';
    fieldConfig.descriptionKey = 'General.user';
    fieldConfig.required = 'true';
    fieldConfig.editable = !this.config?.userNotEditable;
    return fieldConfig;
  }

  public onSubmit(): void {
    this.show_spin = true;
    this.subscribe(this.authProvider.basicAutentication(this.data.user, this.data.password).pipe(
      tap((response: SignatureAuthorizationResponse) => {
        if (response?.status !== SignatureStatus.ERROR) {
          this.dialogRef.close(response);
        } else {
          this.errorMsg = response.errorMessage || 'Contraseña incorrecta';
          this.data.password = undefined;
        }
      }),
      catchError((error: any) => {
        this.errorMsg = this.plycaErrorHandler.getErrorMessage(error);
        return throwError(error);
      }),
      finalize(() => this.show_spin = false)
    ));
  }

}
